import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const Dashboard = () => {
  const { user } = useAuth();
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEnrollments();
  }, []);

  const fetchEnrollments = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('http://localhost:5000/api/my-courses', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEnrollments(response.data);
    } catch (error) {
      console.error('Error fetching enrollments:', error);
    }
    setLoading(false);
  };

  if (loading) return <div className="text-center py-5">Loading...</div>;

  return (
    <div className="container">
      <h1 className="mb-4">My Dashboard</h1>
      <div className="card">
        <div className="card-body">
          <h5>Welcome, {user?.username || 'Student'}!</h5>
          <p>Your enrolled courses: {enrollments.length}</p>
        </div>
      </div>
      <div className="row mt-4">
        {enrollments.map(enrollment => (
          <div className="col-md-4 mb-3" key={enrollment.id}>
            <div className="card">
              <div className="card-body">
                <h5>{enrollment.title}</h5>
                <div className="progress">
                  <div 
                    className="progress-bar" 
                    style={{ width: `${enrollment.progress || 0}%` }}
                  >
                    {enrollment.progress || 0}%
                  </div>
                </div>
                <span className="badge bg-success mt-2">{enrollment.status}</span>
              </div>
            </div>
          </div>
        ))}
        {enrollments.length === 0 && (
          <div className="col-12 text-center">
            <p>You haven't enrolled in any courses yet.</p>
            <a href="/courses" className="btn btn-primary">Browse Courses</a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;